// Initial state for the enrollment form
export const initialState = {
  personal: {
    previouslyStudiedAtCIET: "No",
    studentId: "",
    usiNumber: "",
    title: "",
    givenNames: "",
    familyName: "",
    dateOfBirth: "",
    gender: "",
    countryOfBirth: "",
    citizenship: "",
    passportNumber: "",
    passportExpiry: "",
    passportCountryOfIssue: "",
    passportCopy: null,
    inAustraliaAtApplication: "No",
    yearOfArrival: "",
    maritalStatus: "",
    address: "",
    suburb: "",
    state: "",
    otherState: "",
    country: "",
    postcode: "",
    mobilePhone: "",
    telephone: "",
    emergencyContactName: "",
    emergencyContactRelation: "",
    emergencyContactNumber: "",
    email: "",
    permanentHomeAddress: "",
    agencyName:"",
    agencyId: "",
  },
  campusCourse: {
    campus: "",
    courses: [],
    courseId: []
  },
  intake: {
    month: "",
    year: ""
  },
  visa: {
    visaStatus: "No Visa Yet (Offshore Application)",
    visaType: "",
    appliedBefore: "No",
    granted: "",
    refusalDate: "",
    refusalReason: "",
    embassyOffice: "",
    currentVisaCopy: null,
    refusalLetter: null
  },
  languageCulture: {
    countryOfBirth: "",
    languageAtHome: "English only",
    otherLanguage: "",
    englishTest: "",
    overallScore: "",
    testDate: "",
    currentEnglishCopy: null,
    aboriginalOrTorres: []
  },
  disability: {
    hasDisability: "No",
    areas: []
  },
  schoolingQualifications: {
    highestSchoolLevel: "",
    stillEnrolledSecondary: "No",
    currentlyEnrolledAnyStudies: "No",
    currentProviderName: "",
    currentProviderCourse: "",
    currentProviderContact: "",
    completedQualificationsInEnglish: "No",
    completedLevels: [],
    priorEducationList: [
      {
        institution: "",
        qualification: "",
        location: "",
        yearCompleted: ""
      }
    ],
    transcripts: []
  },
  oshc: {
    arrangeOSHC: "No",
    coverType: "Single"
  },
  employmentStudyReason: {
    employmentStatus: "",
    studyReason: ""
  },
  additionalServices: {
    homestay: "No",
    airportPickup: "No",
    arrivalDetails: ""
  },
  rplCredit: {
    applyCreditTransfer: "No",
    creditUnits: "",
    applyRPL: "No",
    rplUnits: "",
    creditEvidence: []
  },
  usi: {
    usi: "",
    usiExemptionProvided: "No",
    usiExemptionLetter: null
  },
  declaration: {
    confirmTrueAndCorrect: false,
    agreePrivacyNotice: false,
    signatureName: "",
    signature: "",
    signatureDate: "",
    checklist: {
      formCompleted: false,
      passportAttached: false,
      visaAttachedIfApplicable: false,
      englishEvidenceAttached: false,
      readSignedDeclaration: false,
      financialDocsAttached: false,
      gsFormAttached: false,
      transcriptsAttached: false,
    },
    additionalDocuments: []
  }
};
// Initial state for the enrollment form
export const initialStateDomestic = {
  personal: {
    previouslyStudiedAtCIET: "No",
    studentId: "",
    usiNumber: "",
    title: "",
    givenNames: "",
    familyName: "",
    dateOfBirth: "",
    gender: "",
    countryOfBirth: "",
    citizenship: "",
    passportNumber: "",
    passportExpiry: "",
    passportCountryOfIssue: "",
    passportCopy: null,
    inAustraliaAtApplication: "No",
    yearOfArrival: "",
    maritalStatus: "",
    address: "",
    suburb: "",
    state: "",
    country: "",
    postcode: "",
    mobilePhone: "",
    telephone: "",
    email: "",
    permanentHomeAddress: "",
    agencyName:"",
    agencyId: "",
  },
  campusCourse: {
    campus: "",
    courses: [],
    courseId: []
  },
  intake: {
    month: "",
    year: ""
  },
  visa: {
    visaStatus: "Select",
    visaType: "",
    appliedBefore: "No",
    granted: "",
    refusalDate: "",
    refusalReason: "",
    embassyOffice: "",
    currentVisaCopy: null,
    refusalLetter: null
  },
  disability: {
    hasDisability: "No",
    areas: []
  },
  schoolingQualifications: {
    highestSchoolLevel: "",
    stillEnrolledSecondary: "No",
    currentlyEnrolledAnyStudies: "No",
    currentProviderName: "",
    currentProviderCourse: "",
    currentProviderContact: "",
    completedQualificationsInEnglish: "No",
    completedLevels: [],
    priorEducationList: [
      {
        institution: "",
        qualification: "",
        location: "",
        yearCompleted: ""
      }
    ],
    transcripts: []
  },
  employmentStudyReason: {
    employmentStatus: "",
    studyReason: ""
  },
  additionalServices: {
    homestay: "No",
    airportPickup: "No",
    arrivalDetails: ""
  },
  rplCredit: {
    applyCreditTransfer: "No",
    creditUnits: "",
    applyRPL: "No",
    rplUnits: "",
    creditEvidence: []
  },
  usi: {
    usi: "",
    usiExemptionProvided: "No",
    usiExemptionLetter: null
  },
  declaration: {
    confirmTrueAndCorrect: false,
    agreePrivacyNotice: false,
    signatureName: "",
    signatureDate: "",
    signature: "",
    checklist: {
      formCompleted: false,
      passportAttached: false,
      visaAttachedIfApplicable: false,
      readSignedDeclaration: false,
      transcriptsAttached: false,
    },
    additionalDocuments: []
  }
};

// Reducer for managing form state
export function reducer(state, action) {
  switch (action.type) {
    case "SET":
      return {
        ...state,
        [action.section]: {
          ...state[action.section],
          ...action.payload
        }
      };
    
    case "SET_NESTED":
      return {
        ...state,
        [action.section]: {
          ...state[action.section],
          [action.subsection]: {
            ...state[action.section][action.subsection],
            ...action.payload
          }
        }
      };

    case "ADD_PRIOR_EDU":
      return {
        ...state,
        schoolingQualifications: {
          ...state.schoolingQualifications,
          priorEducationList: [
            ...state.schoolingQualifications.priorEducationList,
            {
              institution: "",
              qualification: "",
              location: "",
              yearCompleted: ""
            }
          ]
        }
      };

    case "REMOVE_PRIOR_EDU":
      return {
        ...state,
        schoolingQualifications: {
          ...state.schoolingQualifications,
          priorEducationList: state.schoolingQualifications.priorEducationList.filter(
            (_, index) => index !== action.index
          )
        }
      };

    case "UPDATE_PRIOR_EDU":
      return {
        ...state,
        schoolingQualifications: {
          ...state.schoolingQualifications,
          priorEducationList: state.schoolingQualifications.priorEducationList.map(
            (item, index) => index === action.index ? { ...item, ...action.payload } : item
          )
        }
      };

    case "TOGGLE_ARRAY_ITEM": {
      const currentArray = state[action.section][action.field] || [];
      const newArray = currentArray.includes(action.value)
        ? currentArray.filter(item => item !== action.value)
        : [...currentArray, action.value];
      
      return {
        ...state,
        [action.section]: {
          ...state[action.section],
          [action.field]: newArray
        }
      };
    }

    case "TOGGLE_CHECKLIST":
      return {
        ...state,
        declaration: {
          ...state.declaration,
          checklist: {
            ...state.declaration.checklist,
            [action.key]: !state.declaration.checklist[action.key]
          }
        }
      };

    case "SET_FILES":
      return {
        ...state,
        [action.section]: {
          ...state[action.section],
          [action.field]: action.files
        }
      };

    case "SET_FILE":
      return {
        ...state,
        [action.section]: {
          ...state[action.section],
          [action.field]: action.file
        }
      };

    case "RESET":
      return initialState;

    default:
      return state;
  }
}
// Reducer for managing form state
export function domesticReducer(state, action) {
  switch (action.type) {
    case "SET":
      return {
        ...state,
        [action.section]: {
          ...state[action.section],
          ...action.payload
        }
      };
    
    case "SET_NESTED":
      return {
        ...state,
        [action.section]: {
          ...state[action.section],
          [action.subsection]: {
            ...state[action.section][action.subsection],
            ...action.payload
          }
        }
      };

    case "ADD_PRIOR_EDU":
      return {
        ...state,
        schoolingQualifications: {
          ...state.schoolingQualifications,
          priorEducationList: [
            ...state.schoolingQualifications.priorEducationList,
            {
              institution: "",
              qualification: "",
              location: "",
              yearCompleted: ""
            }
          ]
        }
      };

    case "REMOVE_PRIOR_EDU":
      return {
        ...state,
        schoolingQualifications: {
          ...state.schoolingQualifications,
          priorEducationList: state.schoolingQualifications.priorEducationList.filter(
            (_, index) => index !== action.index
          )
        }
      };

    case "UPDATE_PRIOR_EDU":
      return {
        ...state,
        schoolingQualifications: {
          ...state.schoolingQualifications,
          priorEducationList: state.schoolingQualifications.priorEducationList.map(
            (item, index) => index === action.index ? { ...item, ...action.payload } : item
          )
        }
      };

    case "TOGGLE_ARRAY_ITEM": {
      const currentArray = state[action.section][action.field] || [];
      const newArray = currentArray.includes(action.value)
        ? currentArray.filter(item => item !== action.value)
        : [...currentArray, action.value];
      
      return {
        ...state,
        [action.section]: {
          ...state[action.section],
          [action.field]: newArray
        }
      };
    }

    case "TOGGLE_CHECKLIST":
      return {
        ...state,
        declaration: {
          ...state.declaration,
          checklist: {
            ...state.declaration.checklist,
            [action.key]: !state.declaration.checklist[action.key]
          }
        }
      };

    case "SET_FILES":
      return {
        ...state,
        [action.section]: {
          ...state[action.section],
          [action.field]: action.files
        }
      };

    case "SET_FILE":
      return {
        ...state,
        [action.section]: {
          ...state[action.section],
          [action.field]: action.file
        }
      };

    case "RESET":
      return initialStateDomestic;

    default:
      return state;
  }
}